import { render, staticRenderFns } from "./CabecalhoGruposItens.vue?vue&type=template&id=bcc3c4fe&scoped=true"
import script from "./CabecalhoGruposItens.vue?vue&type=script&lang=js"
export * from "./CabecalhoGruposItens.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcc3c4fe",
  null
  
)

export default component.exports